import { useInfiniteQuery } from "react-query";
import { indexStudents } from "../api/endpoints/tutors/students";
import StudentModel from "../api/models/StudentModel";
import { showApiErrorMessages } from "../helpers";
import { useMemo } from "react";

export function useInfiniteTutorStudents(enabled: boolean) {
  const {
    data: studentsPages,
    fetchNextPage,
    isFetching: isFetchingStudents,
  } = useInfiniteQuery(
    ["tutorStudents"],
    ({ pageParam = 1 }) => {
      return indexStudents({
        pagination: {
          pageSize: 25,
          pageNumber: pageParam,
        },
      });
    },
    {
      enabled,
      select: (data) => {
        let userStudents: StudentModel[] = [];
        return {
          pages: data.pages.map((pageResponse) => {
            if (pageResponse.isSuccess) {
              userStudents = StudentModel.fromApiResponse(pageResponse.data);
            } else {
              showApiErrorMessages(pageResponse);
            }
            return userStudents;
          }),
          pageParams: data.pageParams,
        };
      },
    }
  );

  const students = useMemo(() => {
    if (studentsPages) {
      return studentsPages.pages.flat();
    }
    return [];
  }, [studentsPages]);

  const loadMoreStudents = () => {
    const currentPage = studentsPages?.pages.length;
    if (currentPage) {
      return fetchNextPage({ pageParam: currentPage + 1 });
    }
  };
  return {
    students,
    loadMoreStudents,
    isFetchingStudents,
  };
}
